

// import React, { useState, useEffect } from "react";
// import { Navigate, Link } from 'react-router-dom';
// import { useSelector, useDispatch } from "react-redux";
// import {
//   Card, Avatar, Typography, Button, Tag, Row, Col, Divider,
//   Space, Tooltip, message
// } from "antd";
// import {
//   UserOutlined, EditOutlined, MailOutlined, IdcardOutlined,
//   SafetyOutlined, CrownOutlined, StarOutlined, LockOutlined,
//   CheckCircleOutlined, ClockCircleOutlined, PhoneOutlined,
//   EnvironmentOutlined, CalendarOutlined, BookOutlined
// } from "@ant-design/icons";
// import { getProfile } from "../actions/auth";

// const { Title, Text, Paragraph } = Typography;

// /* ============ Couleurs Nomidya ============ */
// const C = {
//   blue: "#0054A6",
//   blueDark: "#003B75",
//   blueDeep: "#002147",
//   blueLight: "#e8f1fb",
//   orange: "#E8860C",
//   orangeLight: "#FF8C00",
//   orangeBg: "#fff8f0",
//   green: "#00875A",
//   text: "#1a1a1a",
//   textLight: "#6b7280",
//   border: "#e5e7eb",
// };

// const Profile = () => {
//   const [loading, setLoading] = useState(true);
//   const [profileData, setProfileData] = useState(null);

//   const { user: currentUser } = useSelector((state) => state.auth);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     const fetchProfileData = async () => {
//       if (currentUser) {
//         try {
//           setLoading(true);
//           const response = await dispatch(getProfile());
//           setProfileData(response.payload || response);

//           const updatedUser = {
//             ...currentUser,
//             ...response.payload || response
//           };
//           localStorage.setItem("user", JSON.stringify(updatedUser));

//         } catch (error) {
//           console.error('Erreur lors de la récupération du profil:', error);
//           message.error('Erreur lors du chargement du profil');
//         } finally {
//           setLoading(false);
//         }
//       }
//     };

//     fetchProfileData();
//   }, [currentUser, dispatch]);

//   if (!currentUser) {
//     return <Navigate to="/login" />;
//   }

//   const userData = profileData || currentUser;
//   const userRoles = currentUser?.roles || [];
//   const isAdmin = userRoles.includes("ROLE_ADMIN");
//   const isModerator = userRoles.includes("ROLE_MODERATOR");
//   const isUser = userRoles.includes("ROLE_USER");

//   // Couleurs Nomidya pour les badges de rôles
//   const getRoleBadgeColor = (role) => {
//     switch (role) {
//       case "ROLE_ADMIN":
//         return { color: "#fff", background: `linear-gradient(135deg, ${C.orange}, ${C.orangeLight})` };
//       case "ROLE_MODERATOR":
//         return { color: "#fff", background: `linear-gradient(135deg, ${C.green}, #059669)` };
//       case "ROLE_USER":
//         return { color: "#fff", background: `linear-gradient(135deg, ${C.blue}, ${C.blueDark})` };
//       default:
//         return { color: "#666", background: "#f0f0f0" };
//     }
//   };

//   const getRoleName = (role) => {
//     switch (role) {
//       case "ROLE_ADMIN": return "Administrateur";
//       case "ROLE_MODERATOR": return "Modérateur";
//       case "ROLE_USER": return "Utilisateur";
//       default: return role;
//     }
//   };

//   const formatBirthDate = (dateString) => {
//     if (!dateString) return null;
//     const date = new Date(dateString);
//     return date.toLocaleDateString('fr-FR');
//   };

//   /* ============ LOADING - LOADER NOMIDYA ============ */
//   if (loading) {
//     return (
//       <div style={{
//         minHeight: '100vh',
//         background: '#f7f8fa',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '40px 20px',
//       }}>
//         <style>{`
//           @keyframes nomidya-pulse {
//             0%, 100% { transform: scale(1); opacity: 1; }
//             50% { transform: scale(1.1); opacity: 0.7; }
//           }
//           @keyframes nomidya-rotate {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//           @keyframes nomidya-fade-in {
//             from { opacity: 0; transform: translateY(20px); }
//             to { opacity: 1; transform: translateY(0); }
//           }
//           @keyframes nomidya-bounce {
//             0%, 100% { transform: translateY(0); }
//             50% { transform: translateY(-12px); }
//           }
//           @keyframes nomidya-progress {
//             0% { width: 0%; margin-left: 0%; }
//             50% { width: 70%; margin-left: 15%; }
//             100% { width: 0%; margin-left: 100%; }
//           }
//           .nomidya-loader-card {
//             background: white;
//             border-radius: 24px;
//             padding: 60px 50px;
//             box-shadow: 0 25px 50px rgba(0, 84, 166, 0.12);
//             text-align: center;
//             max-width: 500px;
//             width: 100%;
//             animation: nomidya-fade-in 0.6s ease-out;
//             border: 1px solid rgba(0, 84, 166, 0.08);
//           }
//           .nomidya-loader-icon-wrapper {
//             position: relative;
//             width: 100px;
//             height: 100px;
//             margin: 0 auto 32px;
//           }
//           .nomidya-loader-ring {
//             position: absolute;
//             top: 0; left: 0;
//             width: 100px; height: 100px;
//             border-radius: 50%;
//             border: 4px solid transparent;
//             border-top-color: ${C.blue};
//             border-right-color: ${C.orange};
//             animation: nomidya-rotate 1.2s linear infinite;
//           }
//           .nomidya-loader-ring-2 {
//             position: absolute;
//             top: 10px; left: 10px;
//             width: 80px; height: 80px;
//             border-radius: 50%;
//             border: 3px solid transparent;
//             border-bottom-color: ${C.blueDark};
//             border-left-color: ${C.orangeLight};
//             animation: nomidya-rotate 1.5s linear infinite reverse;
//           }
//           .nomidya-loader-center {
//             position: absolute;
//             top: 50%; left: 50%;
//             transform: translate(-50%, -50%);
//             width: 50px; height: 50px;
//             background: linear-gradient(135deg, ${C.blue} 0%, ${C.orange} 100%);
//             border-radius: 12px;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             color: white;
//             font-size: 24px;
//             animation: nomidya-pulse 2s ease-in-out infinite;
//             box-shadow: 0 8px 24px rgba(0, 84, 166, 0.3);
//           }
//           .nomidya-loader-title {
//             font-size: 22px;
//             font-weight: 700;
//             color: ${C.blueDark};
//             margin: 0 0 8px;
//           }
//           .nomidya-loader-subtitle {
//             font-size: 14px;
//             color: ${C.textLight};
//             margin: 0 0 24px;
//           }
//           .nomidya-loader-dots {
//             display: flex;
//             justify-content: center;
//             gap: 10px;
//             margin-top: 20px;
//           }
//           .nomidya-loader-dot {
//             width: 10px;
//             height: 10px;
//             border-radius: 50%;
//             animation: nomidya-bounce 1.4s ease-in-out infinite;
//           }
//           .nomidya-loader-dot:nth-child(1) { background: ${C.blue}; animation-delay: 0s; }
//           .nomidya-loader-dot:nth-child(2) { background: ${C.orange}; animation-delay: 0.2s; }
//           .nomidya-loader-dot:nth-child(3) { background: ${C.blueDark}; animation-delay: 0.4s; }
//           .nomidya-loader-progress {
//             width: 100%;
//             height: 4px;
//             background: #e8eef5;
//             border-radius: 4px;
//             overflow: hidden;
//             margin-top: 24px;
//           }
//           .nomidya-loader-progress-bar {
//             height: 100%;
//             background: linear-gradient(90deg, ${C.blue} 0%, ${C.orange} 100%);
//             border-radius: 4px;
//             width: 30%;
//             animation: nomidya-progress 2s ease-in-out infinite;
//           }
//         `}</style>

//         <div className="nomidya-loader-card">
//           <div className="nomidya-loader-icon-wrapper">
//             <div className="nomidya-loader-ring"></div>
//             <div className="nomidya-loader-ring-2"></div>
//             <div className="nomidya-loader-center">
//               <UserOutlined />
//             </div>
//           </div>
//           <h2 className="nomidya-loader-title">Chargement de votre profil</h2>
//           <p className="nomidya-loader-subtitle">Récupération de vos informations...</p>
//           <div className="nomidya-loader-dots">
//             <div className="nomidya-loader-dot"></div>
//             <div className="nomidya-loader-dot"></div>
//             <div className="nomidya-loader-dot"></div>
//           </div>
//           <div className="nomidya-loader-progress">
//             <div className="nomidya-loader-progress-bar"></div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   /* ============ MAIN RENDER ============ */
//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         background: `linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%)`,
//         padding: "40px 20px",
//         position: "relative",
//         overflow: "hidden",
//       }}
//     >
//       {/* Décorations de fond */}
//       <div style={{
//         position: "absolute",
//         top: -100, right: -100,
//         width: 400, height: 400,
//         background: `radial-gradient(circle, ${C.orange}22 0%, transparent 70%)`,
//         borderRadius: "50%",
//         pointerEvents: "none",
//       }} />
//       <div style={{
//         position: "absolute",
//         bottom: -150, left: -50,
//         width: 300, height: 300,
//         background: `radial-gradient(circle, ${C.blue}66 0%, transparent 70%)`,
//         borderRadius: "50%",
//         pointerEvents: "none",
//       }} />

//       <div style={{ maxWidth: "1000px", margin: "0 auto", position: "relative", zIndex: 1 }}>
//         {/* Header */}
//         <div style={{ textAlign: "center", marginBottom: "40px" }}>
//           <div style={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: 8,
//             background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//             padding: "8px 18px",
//             borderRadius: 30,
//             fontSize: 12,
//             fontWeight: 700,
//             letterSpacing: 1.5,
//             marginBottom: 20,
//             color: "white",
//             textTransform: "uppercase",
//             boxShadow: `0 4px 12px ${C.orange}66`,
//           }}>
//             <UserOutlined /> MON ESPACE
//           </div>
//           <Title
//             level={1}
//             style={{
//               color: "white",
//               textShadow: "0 2px 10px rgba(0,0,0,0.2)",
//               marginBottom: "10px",
//               fontSize: 42,
//               fontWeight: 800,
//             }}
//           >
//             Mon <span style={{
//               background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
//               WebkitBackgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//             }}>Profil</span>
//           </Title>
//           <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 16, display: "block" }}>
//             Informations de votre compte Nomidya
//           </Text>
//         </div>

//         <Row gutter={[30, 30]}>
//           {/* Section Avatar et informations principales */}
//           <Col xs={24} lg={8}>
//             <Card
//               style={{
//                 background: "rgba(255, 255, 255, 0.97)",
//                 borderRadius: "20px",
//                 boxShadow: "0 20px 40px rgba(0, 33, 71, 0.25)",
//                 border: "none",
//                 textAlign: "center",
//                 height: "fit-content",
//               }}
//               bodyStyle={{ padding: "40px" }}
//             >
//               <div style={{ marginBottom: "30px", position: "relative" }}>
//                 <Avatar
//                   size={120}
//                   src={userData?.profileImage || userData?.profile_image}
//                   style={{
//                     background: !userData?.profileImage && !userData?.profile_image ? (
//                       isAdmin
//                         ? `linear-gradient(135deg, ${C.orange}, ${C.orangeLight})`
//                         : isModerator
//                           ? `linear-gradient(135deg, ${C.green}, #059669)`
//                           : `linear-gradient(135deg, ${C.blue}, ${C.blueDark})`
//                     ) : undefined,
//                     border: `4px solid ${C.blue}33`,
//                     boxShadow: "0 8px 25px rgba(0, 84, 166, 0.2)",
//                     marginBottom: "20px",
//                   }}
//                   icon={!userData?.profileImage && !userData?.profile_image && <UserOutlined />}
//                 />

//                 {isAdmin && (
//                   <CrownOutlined
//                     style={{
//                       position: 'absolute',
//                       top: '10px',
//                       right: '10px',
//                       color: C.orange,
//                       fontSize: '24px',
//                       background: '#fff',
//                       borderRadius: '50%',
//                       padding: '4px',
//                       boxShadow: `0 2px 8px ${C.orange}44`,
//                     }}
//                   />
//                 )}
//                 {isModerator && !isAdmin && (
//                   <StarOutlined
//                     style={{
//                       position: 'absolute',
//                       top: '10px',
//                       right: '10px',
//                       color: C.green,
//                       fontSize: '24px',
//                       background: '#fff',
//                       borderRadius: '50%',
//                       padding: '4px',
//                       boxShadow: '0 2px 8px rgba(0, 135, 90, 0.3)',
//                     }}
//                   />
//                 )}
//               </div>

//               <Title level={2} style={{ marginBottom: "10px", color: C.blueDark, fontSize: 24 }}>
//                 {userData.username}
//               </Title>

//               <Paragraph style={{ color: C.textLight, fontSize: "15px", marginBottom: "20px" }}>
//                 <MailOutlined style={{ marginRight: "8px", color: C.blue }} />
//                 {userData.email}
//               </Paragraph>

//               <div style={{ marginBottom: "30px" }}>
//                 <Space wrap>
//                   {userData.roles && userData.roles.map((role, index) => {
//                     const badgeStyle = getRoleBadgeColor(role);
//                     return (
//                       <Tag
//                         key={index}
//                         style={{
//                           ...badgeStyle,
//                           border: "none",
//                           borderRadius: "20px",
//                           padding: "6px 16px",
//                           fontSize: "12px",
//                           fontWeight: "bold",
//                           textTransform: "uppercase",
//                           boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                         }}
//                       >
//                         {getRoleName(role)}
//                       </Tag>
//                     );
//                   })}
//                 </Space>
//               </div>

//               {(userData.bio || userData.phone || userData.location || userData.birthDate || userData.birth_date) && (
//                 <div style={{ marginBottom: "30px", textAlign: "left" }}>
//                   <Divider style={{ margin: "20px 0" }} />
//                   <Space direction="vertical" size="middle" style={{ width: "100%" }}>
//                     {userData.phone && (
//                       <div style={{ display: "flex", alignItems: "center" }}>
//                         <PhoneOutlined style={{ color: C.blue, marginRight: "10px" }} />
//                         <Text>{userData.phone}</Text>
//                       </div>
//                     )}
//                     {userData.location && (
//                       <div style={{ display: "flex", alignItems: "center" }}>
//                         <EnvironmentOutlined style={{ color: C.blue, marginRight: "10px" }} />
//                         <Text>{userData.location}</Text>
//                       </div>
//                     )}
//                     {(userData.birthDate || userData.birth_date) && (
//                       <div style={{ display: "flex", alignItems: "center" }}>
//                         <CalendarOutlined style={{ color: C.blue, marginRight: "10px" }} />
//                         <Text>{formatBirthDate(userData.birthDate || userData.birth_date)}</Text>
//                       </div>
//                     )}
//                     {userData.bio && (
//                       <div>
//                         <Text strong style={{ color: C.blueDark, display: "block", marginBottom: "5px" }}>
//                           Biographie :
//                         </Text>
//                         <Text style={{ fontStyle: "italic", color: C.textLight }}>
//                           {userData.bio}
//                         </Text>
//                       </div>
//                     )}
//                   </Space>
//                 </div>
//               )}

//               <Link to="/profile-management">
//                 <Button
//                   type="primary"
//                   size="large"
//                   icon={<EditOutlined />}
//                   style={{
//                     background: `linear-gradient(135deg, ${C.orange}, ${C.orangeLight})`,
//                     border: "none",
//                     borderRadius: "12px",
//                     height: "48px",
//                     width: "100%",
//                     fontSize: "15px",
//                     fontWeight: "700",
//                     boxShadow: `0 4px 16px ${C.orange}44`,
//                   }}
//                 >
//                   Modifier le profil
//                 </Button>
//               </Link>
//             </Card>
//           </Col>

//           {/* Section Détails du compte */}
//           <Col xs={24} lg={16}>
//             <Card
//               style={{
//                 background: "rgba(255, 255, 255, 0.97)",
//                 borderRadius: "20px",
//                 boxShadow: "0 20px 40px rgba(0, 33, 71, 0.25)",
//                 border: "none",
//               }}
//               bodyStyle={{ padding: "40px" }}
//             >
//               <Title level={3} style={{ marginBottom: "30px", color: C.blueDark, fontSize: 22 }}>
//                 <IdcardOutlined style={{ marginRight: "10px", color: C.blue }} />
//                 Détails du compte
//               </Title>

//               <Row gutter={[20, 30]}>
//                 {/* ID utilisateur */}
//                 <Col xs={24} sm={12}>
//                   <div
//                     style={{
//                       padding: "20px",
//                       background: `${C.blue}10`,
//                       borderRadius: "15px",
//                       border: `1px solid ${C.blue}33`,
//                     }}
//                   >
//                     <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
//                       <IdcardOutlined style={{ color: C.blue, fontSize: "18px", marginRight: "10px" }} />
//                       <Text strong style={{ color: C.blueDark }}>Identifiant</Text>
//                     </div>
//                     <Text style={{ fontSize: "16px", color: C.textLight }}>#{userData.id}</Text>
//                   </div>
//                 </Col>

//                 {/* Statut du compte */}
//                 <Col xs={24} sm={12}>
//                   <div
//                     style={{
//                       padding: "20px",
//                       background: `${C.green}10`,
//                       borderRadius: "15px",
//                       border: `1px solid ${C.green}33`,
//                     }}
//                   >
//                     <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
//                       <CheckCircleOutlined style={{ color: C.green, fontSize: "18px", marginRight: "10px" }} />
//                       <Text strong style={{ color: C.blueDark }}>Statut</Text>
//                     </div>
//                     <Text style={{ fontSize: "16px", color: C.green, fontWeight: "bold" }}>
//                       Compte actif
//                     </Text>
//                   </div>
//                 </Col>

//                 {/* Rôles et Permissions */}
//                 <Col xs={24}>
//                   <div
//                     style={{
//                       padding: "20px",
//                       background: `${C.orange}10`,
//                       borderRadius: "15px",
//                       border: `1px solid ${C.orange}33`,
//                     }}
//                   >
//                     <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
//                       <SafetyOutlined style={{ color: C.orange, fontSize: "18px", marginRight: "10px" }} />
//                       <Text strong style={{ color: C.blueDark }}>Rôles et Permissions</Text>
//                       <Tooltip title="Vos autorisations et privilèges sur la plateforme">
//                         <CrownOutlined style={{ color: C.orange, marginLeft: "8px" }} />
//                       </Tooltip>
//                     </div>

//                     <div style={{ marginBottom: "15px" }}>
//                       <Space wrap>
//                         {userRoles && userRoles.length > 0 ? (
//                           userRoles.map((role, index) => {
//                             const badgeStyle = getRoleBadgeColor(role);
//                             const roleIsAdmin = role === "ROLE_ADMIN";
//                             const roleIsModerator = role === "ROLE_MODERATOR";

//                             return (
//                               <Tag
//                                 key={index}
//                                 style={{
//                                   ...badgeStyle,
//                                   border: "none",
//                                   borderRadius: "20px",
//                                   padding: "8px 16px",
//                                   fontSize: "13px",
//                                   fontWeight: "bold",
//                                   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                                 }}
//                               >
//                                 {roleIsAdmin && <CrownOutlined style={{ marginRight: "6px" }} />}
//                                 {roleIsModerator && <StarOutlined style={{ marginRight: "6px" }} />}
//                                 {role === "ROLE_USER" && <UserOutlined style={{ marginRight: "6px" }} />}
//                                 {getRoleName(role)}
//                               </Tag>
//                             );
//                           })
//                         ) : (
//                           <Tag style={{ color: C.textLight }}>Aucun rôle défini</Tag>
//                         )}
//                       </Space>
//                     </div>

//                     <div
//                       style={{
//                         background: "white",
//                         padding: "14px",
//                         borderRadius: "10px",
//                         fontSize: "13px",
//                         color: C.text,
//                         border: `1px solid ${C.border}`,
//                       }}
//                     >
//                       <Text strong style={{ color: C.blueDark, display: "block", marginBottom: "10px" }}>
//                         ✨ Permissions :
//                       </Text>

//                       {userRoles && userRoles.includes("ROLE_ADMIN") && (
//                         <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Gestion complète de la plateforme</div>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Administration des utilisateurs</div>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Accès à toutes les fonctionnalités</div>
//                         </div>
//                       )}

//                       {userRoles && userRoles.includes("ROLE_MODERATOR") && !userRoles.includes("ROLE_ADMIN") && (
//                         <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Modération de contenu</div>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Création et gestion de cours</div>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Création de formations live</div>
//                         </div>
//                       )}

//                       {userRoles && userRoles.includes("ROLE_USER") && !userRoles.includes("ROLE_ADMIN") && !userRoles.includes("ROLE_MODERATOR") && (
//                         <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Accès aux cours</div>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Inscription aux formations live</div>
//                           <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Gestion du profil personnel</div>
//                         </div>
//                       )}

//                       {(!userRoles || userRoles.length === 0) && (
//                         <Text style={{ color: C.textLight, fontStyle: "italic" }}>
//                           Aucune permission définie
//                         </Text>
//                       )}
//                     </div>
//                   </div>
//                 </Col>
//               </Row>

//               <Divider style={{ margin: "40px 0" }} />

//               {/* Section Actions rapides */}
//               <Title level={4} style={{ marginBottom: "20px", color: C.blueDark, fontSize: 18 }}>
//                 ⚡ Actions rapides
//               </Title>

//               <Row gutter={[15, 15]}>
//                 <Col xs={12} sm={8}>
//                   <Link to="/profile-management">
//                     <Button
//                       block
//                       icon={<EditOutlined />}
//                       style={{
//                         height: "48px",
//                         borderRadius: "12px",
//                         border: `2px solid ${C.blue}`,
//                         color: C.blue,
//                         fontWeight: "700",
//                         background: "white",
//                         transition: "all 0.3s ease",
//                       }}
//                       onMouseEnter={e => { e.currentTarget.style.background = C.blue; e.currentTarget.style.color = "white"; }}
//                       onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.color = C.blue; }}
//                     >
//                       Modifier
//                     </Button>
//                   </Link>
//                 </Col>

//                 <Col xs={12} sm={8}>
//                   <Link to="/change-password">
//                     <Button
//                       block
//                       icon={<LockOutlined />}
//                       style={{
//                         height: "48px",
//                         borderRadius: "12px",
//                         border: `2px solid ${C.green}`,
//                         color: C.green,
//                         fontWeight: "700",
//                         background: "white",
//                         transition: "all 0.3s ease",
//                       }}
//                       onMouseEnter={e => { e.currentTarget.style.background = C.green; e.currentTarget.style.color = "white"; }}
//                       onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.color = C.green; }}
//                     >
//                       Mot de passe
//                     </Button>
//                   </Link>
//                 </Col>

//                 <Col xs={12} sm={8}>
//                   <Link to="/my-purchases">
//                     <Button
//                       block
//                       icon={<ClockCircleOutlined />}
//                       style={{
//                         height: "48px",
//                         borderRadius: "12px",
//                         border: `2px solid ${C.orange}`,
//                         color: C.orange,
//                         fontWeight: "700",
//                         background: "white",
//                         transition: "all 0.3s ease",
//                       }}
//                       onMouseEnter={e => { e.currentTarget.style.background = C.orange; e.currentTarget.style.color = "white"; }}
//                       onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.color = C.orange; }}
//                     >
//                       Mes achats
//                     </Button>
//                   </Link>
//                 </Col>
//               </Row>
//             </Card>
//           </Col>
//         </Row>
//       </div>
//     </div>
//   );
// };

// export default Profile;

import React, { useState, useEffect } from "react";
import { Navigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import {
  Card, Avatar, Typography, Button, Tag, Row, Col, Divider,
  Space, Tooltip, message
} from "antd";
import {
  UserOutlined, EditOutlined, MailOutlined, IdcardOutlined,
  SafetyOutlined, CrownOutlined, StarOutlined, LockOutlined,
  CheckCircleOutlined, ClockCircleOutlined, PhoneOutlined,
  EnvironmentOutlined, CalendarOutlined, BookOutlined
} from "@ant-design/icons";
import { getProfile } from "../actions/auth";

const { Title, Text, Paragraph } = Typography;

/* ============ Couleurs Nomidya ============ */
const C = {
  blue: "#0054A6",
  blueDark: "#003B75",
  blueDeep: "#002147",
  blueLight: "#e8f1fb",
  orange: "#E8860C",
  orangeLight: "#FF8C00",
  orangeBg: "#fff8f0",
  green: "#00875A",
  text: "#1a1a1a",
  textLight: "#6b7280",
  border: "#e5e7eb",
};

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [profileData, setProfileData] = useState(null);

  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchProfileData = async () => {
      if (currentUser) {
        try {
          setLoading(true);
          const response = await dispatch(getProfile());
          setProfileData(response.payload || response);

          const updatedUser = {
            ...currentUser,
            ...response.payload || response
          };
          localStorage.setItem("user", JSON.stringify(updatedUser));

        } catch (error) {
          console.error('Erreur lors de la récupération du profil:', error);
          message.error('Erreur lors du chargement du profil');
        } finally {
          setLoading(false);
        }
      }
    };

    fetchProfileData();
  }, [currentUser, dispatch]);

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  const userData = profileData || currentUser;
  const userRoles = currentUser?.roles || [];
  const isAdmin = userRoles.includes("ROLE_ADMIN");
  const isModerator = userRoles.includes("ROLE_MODERATOR");
  const isUser = userRoles.includes("ROLE_USER");

  // ✅ NOUVEAU : Helper pour résoudre le nom d'affichage
  //    Priorité : fullName > username
  const getDisplayName = () => {
    const fullName = userData.fullName || userData.full_name;
    if (fullName && String(fullName).trim()) {
      return String(fullName).trim();
    }
    return userData.username;
  };

  // ✅ NOUVEAU : Vérifier si fullName est différent de username
  //    (utile pour afficher les 2 si différents)
  const hasDistinctFullName = () => {
    const fullName = userData.fullName || userData.full_name;
    return fullName
      && String(fullName).trim()
      && String(fullName).trim() !== userData.username;
  };

  // Couleurs Nomidya pour les badges de rôles
  const getRoleBadgeColor = (role) => {
    switch (role) {
      case "ROLE_ADMIN":
        return { color: "#fff", background: `linear-gradient(135deg, ${C.orange}, ${C.orangeLight})` };
      case "ROLE_MODERATOR":
        return { color: "#fff", background: `linear-gradient(135deg, ${C.green}, #059669)` };
      case "ROLE_USER":
        return { color: "#fff", background: `linear-gradient(135deg, ${C.blue}, ${C.blueDark})` };
      default:
        return { color: "#666", background: "#f0f0f0" };
    }
  };

  const getRoleName = (role) => {
    switch (role) {
      case "ROLE_ADMIN": return "Administrateur";
      case "ROLE_MODERATOR": return "Modérateur";
      case "ROLE_USER": return "Utilisateur";
      default: return role;
    }
  };

  const formatBirthDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR');
  };

  /* ============ LOADING - LOADER NOMIDYA ============ */
  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        background: '#f7f8fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
      }}>
        <style>{`
          @keyframes nomidya-pulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.1); opacity: 0.7; }
          }
          @keyframes nomidya-rotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes nomidya-fade-in {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes nomidya-bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-12px); }
          }
          @keyframes nomidya-progress {
            0% { width: 0%; margin-left: 0%; }
            50% { width: 70%; margin-left: 15%; }
            100% { width: 0%; margin-left: 100%; }
          }
          .nomidya-loader-card {
            background: white;
            border-radius: 24px;
            padding: 60px 50px;
            box-shadow: 0 25px 50px rgba(0, 84, 166, 0.12);
            text-align: center;
            max-width: 500px;
            width: 100%;
            animation: nomidya-fade-in 0.6s ease-out;
            border: 1px solid rgba(0, 84, 166, 0.08);
          }
          .nomidya-loader-icon-wrapper {
            position: relative;
            width: 100px;
            height: 100px;
            margin: 0 auto 32px;
          }
          .nomidya-loader-ring {
            position: absolute;
            top: 0; left: 0;
            width: 100px; height: 100px;
            border-radius: 50%;
            border: 4px solid transparent;
            border-top-color: ${C.blue};
            border-right-color: ${C.orange};
            animation: nomidya-rotate 1.2s linear infinite;
          }
          .nomidya-loader-ring-2 {
            position: absolute;
            top: 10px; left: 10px;
            width: 80px; height: 80px;
            border-radius: 50%;
            border: 3px solid transparent;
            border-bottom-color: ${C.blueDark};
            border-left-color: ${C.orangeLight};
            animation: nomidya-rotate 1.5s linear infinite reverse;
          }
          .nomidya-loader-center {
            position: absolute;
            top: 50%; left: 50%;
            transform: translate(-50%, -50%);
            width: 50px; height: 50px;
            background: linear-gradient(135deg, ${C.blue} 0%, ${C.orange} 100%);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 24px;
            animation: nomidya-pulse 2s ease-in-out infinite;
            box-shadow: 0 8px 24px rgba(0, 84, 166, 0.3);
          }
          .nomidya-loader-title {
            font-size: 22px;
            font-weight: 700;
            color: ${C.blueDark};
            margin: 0 0 8px;
          }
          .nomidya-loader-subtitle {
            font-size: 14px;
            color: ${C.textLight};
            margin: 0 0 24px;
          }
          .nomidya-loader-dots {
            display: flex;
            justify-content: center;
            gap: 10px;
            margin-top: 20px;
          }
          .nomidya-loader-dot {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            animation: nomidya-bounce 1.4s ease-in-out infinite;
          }
          .nomidya-loader-dot:nth-child(1) { background: ${C.blue}; animation-delay: 0s; }
          .nomidya-loader-dot:nth-child(2) { background: ${C.orange}; animation-delay: 0.2s; }
          .nomidya-loader-dot:nth-child(3) { background: ${C.blueDark}; animation-delay: 0.4s; }
          .nomidya-loader-progress {
            width: 100%;
            height: 4px;
            background: #e8eef5;
            border-radius: 4px;
            overflow: hidden;
            margin-top: 24px;
          }
          .nomidya-loader-progress-bar {
            height: 100%;
            background: linear-gradient(90deg, ${C.blue} 0%, ${C.orange} 100%);
            border-radius: 4px;
            width: 30%;
            animation: nomidya-progress 2s ease-in-out infinite;
          }
        `}</style>

        <div className="nomidya-loader-card">
          <div className="nomidya-loader-icon-wrapper">
            <div className="nomidya-loader-ring"></div>
            <div className="nomidya-loader-ring-2"></div>
            <div className="nomidya-loader-center">
              <UserOutlined />
            </div>
          </div>
          <h2 className="nomidya-loader-title">Chargement de votre profil</h2>
          <p className="nomidya-loader-subtitle">Récupération de vos informations...</p>
          <div className="nomidya-loader-dots">
            <div className="nomidya-loader-dot"></div>
            <div className="nomidya-loader-dot"></div>
            <div className="nomidya-loader-dot"></div>
          </div>
          <div className="nomidya-loader-progress">
            <div className="nomidya-loader-progress-bar"></div>
          </div>
        </div>
      </div>
    );
  }

  /* ============ MAIN RENDER ============ */
  return (
    <div
      style={{
        minHeight: "100vh",
        background: `linear-gradient(135deg, ${C.blueDeep} 0%, ${C.blueDark} 50%, ${C.blue} 100%)`,
        padding: "40px 20px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Décorations de fond */}
      <div style={{
        position: "absolute",
        top: -100, right: -100,
        width: 400, height: 400,
        background: `radial-gradient(circle, ${C.orange}22 0%, transparent 70%)`,
        borderRadius: "50%",
        pointerEvents: "none",
      }} />
      <div style={{
        position: "absolute",
        bottom: -150, left: -50,
        width: 300, height: 300,
        background: `radial-gradient(circle, ${C.blue}66 0%, transparent 70%)`,
        borderRadius: "50%",
        pointerEvents: "none",
      }} />

      <div style={{ maxWidth: "1000px", margin: "0 auto", position: "relative", zIndex: 1 }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
            padding: "8px 18px",
            borderRadius: 30,
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: 1.5,
            marginBottom: 20,
            color: "white",
            textTransform: "uppercase",
            boxShadow: `0 4px 12px ${C.orange}66`,
          }}>
            <UserOutlined /> MON ESPACE
          </div>
          <Title
            level={1}
            style={{
              color: "white",
              textShadow: "0 2px 10px rgba(0,0,0,0.2)",
              marginBottom: "10px",
              fontSize: 42,
              fontWeight: 800,
            }}
          >
            Mon <span style={{
              background: `linear-gradient(135deg, ${C.orange} 0%, ${C.orangeLight} 100%)`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}>Profil</span>
          </Title>
          <Text style={{ color: "rgba(255,255,255,0.85)", fontSize: 16, display: "block" }}>
            Informations de votre compte Nomidya
          </Text>
        </div>

        <Row gutter={[30, 30]}>
          {/* Section Avatar et informations principales */}
          <Col xs={24} lg={8}>
            <Card
              style={{
                background: "rgba(255, 255, 255, 0.97)",
                borderRadius: "20px",
                boxShadow: "0 20px 40px rgba(0, 33, 71, 0.25)",
                border: "none",
                textAlign: "center",
                height: "fit-content",
              }}
              bodyStyle={{ padding: "40px" }}
            >
              <div style={{ marginBottom: "30px", position: "relative" }}>
                <Avatar
                  size={120}
                  src={userData?.profileImage || userData?.profile_image}
                  style={{
                    background: !userData?.profileImage && !userData?.profile_image ? (
                      isAdmin
                        ? `linear-gradient(135deg, ${C.orange}, ${C.orangeLight})`
                        : isModerator
                          ? `linear-gradient(135deg, ${C.green}, #059669)`
                          : `linear-gradient(135deg, ${C.blue}, ${C.blueDark})`
                    ) : undefined,
                    border: `4px solid ${C.blue}33`,
                    boxShadow: "0 8px 25px rgba(0, 84, 166, 0.2)",
                    marginBottom: "20px",
                  }}
                  icon={!userData?.profileImage && !userData?.profile_image && <UserOutlined />}
                />

                {isAdmin && (
                  <CrownOutlined
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      color: C.orange,
                      fontSize: '24px',
                      background: '#fff',
                      borderRadius: '50%',
                      padding: '4px',
                      boxShadow: `0 2px 8px ${C.orange}44`,
                    }}
                  />
                )}
                {isModerator && !isAdmin && (
                  <StarOutlined
                    style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      color: C.green,
                      fontSize: '24px',
                      background: '#fff',
                      borderRadius: '50%',
                      padding: '4px',
                      boxShadow: '0 2px 8px rgba(0, 135, 90, 0.3)',
                    }}
                  />
                )}
              </div>

              {/* ✅ NOUVEAU : Titre principal = fullName (priorité) */}
              <Title level={2} style={{ marginBottom: "4px", color: C.blueDark, fontSize: 24 }}>
                {getDisplayName()}
              </Title>

              {/* ✅ NOUVEAU : Sous-titre = @username (si différent du fullName affiché) */}
              {hasDistinctFullName() && (
                <Text
                  style={{
                    display: "block",
                    color: C.textLight,
                    fontSize: 13,
                    marginBottom: 10,
                    fontWeight: 500,
                  }}
                >
                  @{userData.username}
                </Text>
              )}

              <Paragraph style={{ color: C.textLight, fontSize: "15px", marginBottom: "20px", marginTop: 8 }}>
                <MailOutlined style={{ marginRight: "8px", color: C.blue }} />
                {userData.email}
              </Paragraph>

              <div style={{ marginBottom: "30px" }}>
                <Space wrap>
                  {userData.roles && userData.roles.map((role, index) => {
                    const badgeStyle = getRoleBadgeColor(role);
                    return (
                      <Tag
                        key={index}
                        style={{
                          ...badgeStyle,
                          border: "none",
                          borderRadius: "20px",
                          padding: "6px 16px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        }}
                      >
                        {getRoleName(role)}
                      </Tag>
                    );
                  })}
                </Space>
              </div>

              {(userData.bio || userData.phone || userData.location || userData.birthDate || userData.birth_date) && (
                <div style={{ marginBottom: "30px", textAlign: "left" }}>
                  <Divider style={{ margin: "20px 0" }} />
                  <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                    {userData.phone && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <PhoneOutlined style={{ color: C.blue, marginRight: "10px" }} />
                        <Text>{userData.phone}</Text>
                      </div>
                    )}
                    {userData.location && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <EnvironmentOutlined style={{ color: C.blue, marginRight: "10px" }} />
                        <Text>{userData.location}</Text>
                      </div>
                    )}
                    {(userData.birthDate || userData.birth_date) && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <CalendarOutlined style={{ color: C.blue, marginRight: "10px" }} />
                        <Text>{formatBirthDate(userData.birthDate || userData.birth_date)}</Text>
                      </div>
                    )}
                    {userData.bio && (
                      <div>
                        <Text strong style={{ color: C.blueDark, display: "block", marginBottom: "5px" }}>
                          Biographie :
                        </Text>
                        <Text style={{ fontStyle: "italic", color: C.textLight }}>
                          {userData.bio}
                        </Text>
                      </div>
                    )}
                  </Space>
                </div>
              )}

              <Link to="/profile-management">
                <Button
                  type="primary"
                  size="large"
                  icon={<EditOutlined />}
                  style={{
                    background: `linear-gradient(135deg, ${C.orange}, ${C.orangeLight})`,
                    border: "none",
                    borderRadius: "12px",
                    height: "48px",
                    width: "100%",
                    fontSize: "15px",
                    fontWeight: "700",
                    boxShadow: `0 4px 16px ${C.orange}44`,
                  }}
                >
                  Modifier le profil
                </Button>
              </Link>
            </Card>
          </Col>

          {/* Section Détails du compte */}
          <Col xs={24} lg={16}>
            <Card
              style={{
                background: "rgba(255, 255, 255, 0.97)",
                borderRadius: "20px",
                boxShadow: "0 20px 40px rgba(0, 33, 71, 0.25)",
                border: "none",
              }}
              bodyStyle={{ padding: "40px" }}
            >
              <Title level={3} style={{ marginBottom: "30px", color: C.blueDark, fontSize: 22 }}>
                <IdcardOutlined style={{ marginRight: "10px", color: C.blue }} />
                Détails du compte
              </Title>

              <Row gutter={[20, 30]}>
                {/* ID utilisateur */}
                <Col xs={24} sm={12}>
                  <div
                    style={{
                      padding: "20px",
                      background: `${C.blue}10`,
                      borderRadius: "15px",
                      border: `1px solid ${C.blue}33`,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                      <IdcardOutlined style={{ color: C.blue, fontSize: "18px", marginRight: "10px" }} />
                      <Text strong style={{ color: C.blueDark }}>Identifiant</Text>
                    </div>
                    <Text style={{ fontSize: "16px", color: C.textLight }}>#{userData.id}</Text>
                  </div>
                </Col>

                {/* Statut du compte */}
                <Col xs={24} sm={12}>
                  <div
                    style={{
                      padding: "20px",
                      background: `${C.green}10`,
                      borderRadius: "15px",
                      border: `1px solid ${C.green}33`,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                      <CheckCircleOutlined style={{ color: C.green, fontSize: "18px", marginRight: "10px" }} />
                      <Text strong style={{ color: C.blueDark }}>Statut</Text>
                    </div>
                    <Text style={{ fontSize: "16px", color: C.green, fontWeight: "bold" }}>
                      Compte actif
                    </Text>
                  </div>
                </Col>

                {/* ✅ NOUVEAU : Nom complet */}
                <Col xs={24} sm={12}>
                  <div
                    style={{
                      padding: "20px",
                      background: `${C.orange}10`,
                      borderRadius: "15px",
                      border: `1px solid ${C.orange}33`,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                      <IdcardOutlined style={{ color: C.orange, fontSize: "18px", marginRight: "10px" }} />
                      <Text strong style={{ color: C.blueDark }}>Nom complet</Text>
                    </div>
                    <Text style={{ fontSize: "15px", color: C.text, fontWeight: 600 }}>
                      {getDisplayName()}
                    </Text>
                    <div style={{ marginTop: 6 }}>
                      <Text style={{ fontSize: 10, color: C.textLight, fontStyle: "italic" }}>
                        Utilisé pour vos certificats
                      </Text>
                    </div>
                  </div>
                </Col>

                {/* Nom d'utilisateur */}
                <Col xs={24} sm={12}>
                  <div
                    style={{
                      padding: "20px",
                      background: `${C.blue}10`,
                      borderRadius: "15px",
                      border: `1px solid ${C.blue}33`,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                      <UserOutlined style={{ color: C.blue, fontSize: "18px", marginRight: "10px" }} />
                      <Text strong style={{ color: C.blueDark }}>Nom d'utilisateur</Text>
                    </div>
                    <Text style={{ fontSize: "15px", color: C.text, fontWeight: 600 }}>
                      @{userData.username}
                    </Text>
                    <div style={{ marginTop: 6 }}>
                      <Text style={{ fontSize: 10, color: C.textLight, fontStyle: "italic" }}>
                        Utilisé pour la connexion
                      </Text>
                    </div>
                  </div>
                </Col>

                {/* Rôles et Permissions */}
                <Col xs={24}>
                  <div
                    style={{
                      padding: "20px",
                      background: `${C.orange}10`,
                      borderRadius: "15px",
                      border: `1px solid ${C.orange}33`,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                      <SafetyOutlined style={{ color: C.orange, fontSize: "18px", marginRight: "10px" }} />
                      <Text strong style={{ color: C.blueDark }}>Rôles et Permissions</Text>
                      <Tooltip title="Vos autorisations et privilèges sur la plateforme">
                        <CrownOutlined style={{ color: C.orange, marginLeft: "8px" }} />
                      </Tooltip>
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                      <Space wrap>
                        {userRoles && userRoles.length > 0 ? (
                          userRoles.map((role, index) => {
                            const badgeStyle = getRoleBadgeColor(role);
                            const roleIsAdmin = role === "ROLE_ADMIN";
                            const roleIsModerator = role === "ROLE_MODERATOR";

                            return (
                              <Tag
                                key={index}
                                style={{
                                  ...badgeStyle,
                                  border: "none",
                                  borderRadius: "20px",
                                  padding: "8px 16px",
                                  fontSize: "13px",
                                  fontWeight: "bold",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                }}
                              >
                                {roleIsAdmin && <CrownOutlined style={{ marginRight: "6px" }} />}
                                {roleIsModerator && <StarOutlined style={{ marginRight: "6px" }} />}
                                {role === "ROLE_USER" && <UserOutlined style={{ marginRight: "6px" }} />}
                                {getRoleName(role)}
                              </Tag>
                            );
                          })
                        ) : (
                          <Tag style={{ color: C.textLight }}>Aucun rôle défini</Tag>
                        )}
                      </Space>
                    </div>

                    <div
                      style={{
                        background: "white",
                        padding: "14px",
                        borderRadius: "10px",
                        fontSize: "13px",
                        color: C.text,
                        border: `1px solid ${C.border}`,
                      }}
                    >
                      <Text strong style={{ color: C.blueDark, display: "block", marginBottom: "10px" }}>
                        ✨ Permissions :
                      </Text>

                      {userRoles && userRoles.includes("ROLE_ADMIN") && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Gestion complète de la plateforme</div>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Administration des utilisateurs</div>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Accès à toutes les fonctionnalités</div>
                        </div>
                      )}

                      {userRoles && userRoles.includes("ROLE_MODERATOR") && !userRoles.includes("ROLE_ADMIN") && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Modération de contenu</div>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Création et gestion de cours</div>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Création de formations live</div>
                        </div>
                      )}

                      {userRoles && userRoles.includes("ROLE_USER") && !userRoles.includes("ROLE_ADMIN") && !userRoles.includes("ROLE_MODERATOR") && (
                        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Accès aux cours</div>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Inscription aux formations live</div>
                          <div><CheckCircleOutlined style={{ color: C.green, marginRight: 8 }} />Gestion du profil personnel</div>
                        </div>
                      )}

                      {(!userRoles || userRoles.length === 0) && (
                        <Text style={{ color: C.textLight, fontStyle: "italic" }}>
                          Aucune permission définie
                        </Text>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <Divider style={{ margin: "40px 0" }} />

              {/* Section Actions rapides */}
              <Title level={4} style={{ marginBottom: "20px", color: C.blueDark, fontSize: 18 }}>
                ⚡ Actions rapides
              </Title>

              <Row gutter={[15, 15]}>
                <Col xs={12} sm={8}>
                  <Link to="/profile-management">
                    <Button
                      block
                      icon={<EditOutlined />}
                      style={{
                        height: "48px",
                        borderRadius: "12px",
                        border: `2px solid ${C.blue}`,
                        color: C.blue,
                        fontWeight: "700",
                        background: "white",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={e => { e.currentTarget.style.background = C.blue; e.currentTarget.style.color = "white"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.color = C.blue; }}
                    >
                      Modifier
                    </Button>
                  </Link>
                </Col>

                <Col xs={12} sm={8}>
                  <Link to="/change-password">
                    <Button
                      block
                      icon={<LockOutlined />}
                      style={{
                        height: "48px",
                        borderRadius: "12px",
                        border: `2px solid ${C.green}`,
                        color: C.green,
                        fontWeight: "700",
                        background: "white",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={e => { e.currentTarget.style.background = C.green; e.currentTarget.style.color = "white"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.color = C.green; }}
                    >
                      Mot de passe
                    </Button>
                  </Link>
                </Col>

                <Col xs={12} sm={8}>
                  <Link to="/my-purchases">
                    <Button
                      block
                      icon={<ClockCircleOutlined />}
                      style={{
                        height: "48px",
                        borderRadius: "12px",
                        border: `2px solid ${C.orange}`,
                        color: C.orange,
                        fontWeight: "700",
                        background: "white",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={e => { e.currentTarget.style.background = C.orange; e.currentTarget.style.color = "white"; }}
                      onMouseLeave={e => { e.currentTarget.style.background = "white"; e.currentTarget.style.color = C.orange; }}
                    >
                      Mes achats
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Profile;